import React, { useState } from 'react';
import PortalPage from '../../../components/portal/PortalPage'
import './administration.css';
import { RouteComponentProps } from 'react-router';
import { useParams } from 'react-router-dom';
import { userHasPermission, useUserRoles } from 'hooks/useRoles';
import { ITabProps, TabButtons } from 'components/ui/TabButtons';
import { GeneralAdministrationModule } from './general-administration-data';
import { AccessDenied } from 'components/ui/AccessDenied';
import { IConfirmProps } from '../../ui/ConfirmationBox';
import { IModalBoxProps } from '../../ui/ModalBox';

interface IGeneralAdministrationPageProps {
    module: string
}

const GeneralAdministrationPage = (props: RouteComponentProps<IGeneralAdministrationPageProps>) => {
    const params = useParams();
    const [loadingState, setLoadingState] = useState("ready");
    const [confirmationProps, setConfirmationProps] = useState(null as IConfirmProps | null);
    const [modalProps, setModalProps] = useState(null as IModalBoxProps | null);

    const userRoles = useUserRoles();

    const userTabs = (
        !GeneralAdministrationModule.children ? [] as ITabProps[] :
            GeneralAdministrationModule.children.filter(
                subModule => userHasPermission(subModule.permission, userRoles)
            ).map(
                subModule => { return { ...subModule } as ITabProps }
            )
    );

    const getDefaultTab = (): ITabProps | null => {
        if (userTabs.length > 0) {
            if (params.module) {
                return userTabs.find(t => t.url?.endsWith("/" + params.module)) ?? null;
            } else {
                if (userTabs.length > 0) {
                    return userTabs[0];
                }
            }
        }

        return null;
    };

    const [currentTab, setCurrentTab] = useState(getDefaultTab());

    if (!currentTab) {
        const defTab = getDefaultTab();
        if (defTab) {
            setCurrentTab(defTab);
        }
    }

    const TabComponent = currentTab?.component;

    const tabComponentProps = {
        confirmProps: confirmationProps,
        setConfirmProps: setConfirmationProps,

        modalProps: modalProps,
        setModalProps: setModalProps,

        module: GeneralAdministrationModule.children?.find(m => m.title === currentTab?.title)
    };

    return (
        <PortalPage module="administration"
            page={GeneralAdministrationModule.className}
            loadingState={loadingState}
            title={GeneralAdministrationModule.title}
            route={currentTab?.url ?? ""}
            icon={GeneralAdministrationModule.icon}
            confirmationProps={confirmationProps}
            modalProps={modalProps}>

            <TabButtons tabs={userTabs}
                selected={currentTab}
                onSelected={setCurrentTab}
                userRoles={userRoles} />

            {TabComponent && <TabComponent {...tabComponentProps} />}

            {userTabs.length === 0 &&
                <AccessDenied />
            }
        </PortalPage>
    );
};

export default GeneralAdministrationPage;